import type { ISearchEnginesKeywordsProps } from "app/components/React/Table/cells/SearchEnginesKeywordCell/SearchEnginesKeywordCellConst";
import type { IBPCampaignDataFromServer } from "app/pages/digital-marketing/brand-monitoring-campaigns/wizard/BPCampaignsWizard.types";
import type { IKeywordsCampaignData } from "app/pages/digital-marketing/keywords-campaigns/infra/KeywordsCampaignTypes";
import type { TagsOfKeywordCellSingleItem } from "app/pages/digital-marketing/keywords-campaigns/shared/components/TagsOfKeywordCell/types";
import type { DEVICES_TYPES_FOR_API } from "app/UtilitiesAndConstants/Constants/DevicesTypes";

import type { ILocationDetailsToPresent } from "../campaigns-wizard/CampaignsWizardConsts";
import type {
    ICampaignsSearchEngineCompany,
    ESearchEngineDevice,
    ICampaignsLanguage,
} from "../searchEngine/SearchEnginesConsts";

export type ICampaignDataUnion = IKeywordsCampaignData | IBPCampaignDataFromServer;
export type ICampaignsDataUnion = ICampaignDataUnion[];

export interface ICampaignsBaseScrapingConfiguration {
    id?: string;
    searchEngine: string;
    geoLocation: string;
    device: DEVICES_TYPES_FOR_API;
    locale: string;
    geoLocationType: string;
    keywords: string[];
}

export interface ICampaignsScrapingConfiguration extends ICampaignsBaseScrapingConfiguration {
    geoLocationCountry: number;
}

export interface ICampaignsWizardNoDataError {
    id?: string;
    key?: string | number;
    location?: ILocationDetailsToPresent;
    company?: ICampaignsSearchEngineCompany;
    device?: ESearchEngineDevice;
    language?: ICampaignsLanguage;
    keyword?: string;
    tags?: TagsOfKeywordCellSingleItem[];
    searchEngine?: ISearchEnginesKeywordsProps[];
}

export const SHARED_ICON_NAME = "users";
export const SETTINGS_ICON_NAME = "settings";
export const SUBSCRIBE_ICON_NAME = "alerts";

// Keywords report quick-filter preset cards (useCaseFilter wire values)
export const keywordsReportTableFiltersMap = {
    OPPORTUNITIES: "opportunities",
    AIO_CITATION: "aioCitation",
    ORGANIC_CANNIBALIZATION: "organicCannibalization",
    PAID_CANNIBALIZATION: "paidCannibalization",
    TRAFFIC_DRIVERS: "trafficDrivers",
    TARGET_URL_MIS_RANK: "targetUrlMisRank",
    DROPPED: "dropped",
    COMPETITOR_WINNING: "competitorWinning",
} as const;

export type KeywordsReportTableFilter =
    (typeof keywordsReportTableFiltersMap)[keyof typeof keywordsReportTableFiltersMap];
